module.exports = __webpack_public_path__ + "static/img/33.eeb999c.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/notice/33.png
// module id = dKOK
// module chunks = 1